module.exports = __webpack_public_path__ + "img/front-bushes.22678592.webp";